import { useSelector } from "react-redux";
import OverallInfo from "./OverallInfo";
import Loading from "../Ui/Loading";
import infoBgImg from "../../resources/images/app/banner_background.png";
import { useEffect, useState } from "react";
const InfoBar = () => {
  const shopInfoDataResponse = useSelector(
    (state: any) => state.shopInfo.shopInfoData
    );
    const [receivedData,setReceivedData]=useState(false)
  useEffect(() => {
   setReceivedData(Object.keys(shopInfoDataResponse).length !==0)
  }, [shopInfoDataResponse])

  return (
    <div className="relative mt-16 mx-3 sm:mx-4 overflow-hidden rounded-3xl bg-gradient-to-br from-emerald-500 to-emerald-700 shadow-lg min-h-[110px] max-h-[210px] sm:min-h-[250px] md:min-h-[300px] xl:min-h-[400px]">
      <img
        src={infoBgImg}
        alt=""
        // className="absolute top-14 bottom-3 right-3 sm:top-16 sm:bottom-4 sm:right-4 w-[52%] sm:w-1/2 md:w-[46%] rounded-2xl object-cover shadow-lg pointer-events-none select-none"
        className="h-full w-full object-cover pointer-events-none select-none"
      />
      <div className="absolute inset-0 bg-black/30 pointer-events-none" />
      {receivedData ? (
        <OverallInfo />
      ) : (
        <div className="flex items-center justify-center h-full min-h-[210px]">
          <Loading />
        </div>
      )}
    </div>
  );
};

export default InfoBar;
